/**
活动详情页时间轴滑块
callback:回调函数；
options:选项数组；
selectedOption:选中的选项；
author by fanglijuan 2018-01-12
**/
'use strict';
angular.module('util.dateSlider', []).
directive('dateSlider', ['$timeout', '$filter', function($timeout, $filter) {
    return {
        scope: {
            callback: "&",
            dateArray: "=",
            selectedDateRange: "=",
        },
        restrict: 'E',
        templateUrl: './utils/dateSlider/dateSlider_tpl.html',
        link: function(scope, $element, $attrs) {
            initStatus();
            initData();
            scope.setSelected = function(option) {
                scope.selectedOption = option;
                $timeout(function() {
                    scope.callback();
                });
            };
            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                scope.status = {};
            }
            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {
                selectDateRage(scope.dateArray[0]);
                initSilder();
            }
            /**
             * [selectDateRage description] 选中日期段
             * @param  {[type]} items [description] 日期组
             * @return {[type]} [description]
             */
            function selectDateRage(items) {
                scope.selectedDateRange = items;
                scope.callback();
            }
            scope.selectDateRage = selectDateRage;
            /**
             * [initDateRange description] 初始化日期段
             * @param  {[type]} items [description] 日期组
             * @return {[type]}       [description]
             */
            scope.initDateRange = function(items) {
                var startDate = $filter('date')(items[0].start, "MM.dd");
                var endDate = $filter('date')(items[0].end - (1000 * 3600 * 24), "MM.dd");
                if (startDate !== endDate) {
                    items.dateRange = startDate + "-" + endDate;
                } else {
                    items.dateRange = startDate;
                }
            };
            /**
             * [initSilder description] 初始化滑动事件
             * @return {[type]} [description]
             */
            function initSilder() {
                var watch = scope.$watch("$parent.status.isShowTimeDetal", function(newV) {
                    if (newV) {
                        $timeout(function() {
                            watch();
                            scope.status.divWidth = $element.find(".div")[0].offsetWidth;
                            scope.status.lisWidth = 0;
                            $element.find("li").each(function() {
                                scope.status.lisWidth += this.offsetWidth;
                            });
                            scope.status.ulStyle = { width: scope.status.lisWidth + 100 };
                            scope.status.perLiWidth = $element.find("li").eq(0)[0].offsetWidth;
                            scope.status.cannotLeft = true;
                            if (scope.status.divWidth <= scope.status.lisWidth) {
                                scope.status.cannotRight = false;
                            } else {
                                scope.status.cannotRight = true;
                            }
                        }, 100);
                    }
                });
            }
            /**
             * [sliderLeft description] 左滑
             * @return {[type]} [description]
             */
            scope.sliderLeft = function() {
                if (scope.status.cannotLeft) return;
                $timeout(function() {
                    var $ul = $element.find("ul");
                    var left = Number($ul.css("left").replace(/px/, ""));
                    scope.status.cannotLeft = true;
                    if (left !== 0) {
                        $ul.stop(true, true).animate({ left: left + scope.status.perLiWidth }, 100, function() {
                            $timeout(function() {
                                scope.status.cannotRight = false;
                                left = Number($ul.css("left").replace(/px/, ""));
                                if (left !== 0) {
                                    scope.status.cannotLeft = false;
                                } else {
                                    scope.status.cannotLeft = true;
                                }
                            });
                        });
                    } else {
                        scope.status.cannotLeft = true;
                    }
                });
            };
            /**
             * [sliderLeft description] 左滑
             * @return {[type]} [description]
             */
            scope.sliderRight = function() {
                if (scope.status.cannotRight) return;
                $timeout(function() {
                    var $ul = $element.find("ul");
                    var left = Number($ul.css("left").replace(/px/, ""));
                    scope.status.cannotRight = true;
                    if ((scope.status.lisWidth + left) > scope.status.divWidth) {
                        $ul.stop(true, true).animate({ left: left - scope.status.perLiWidth }, 100, function() {
                            $timeout(function() {
                                scope.status.cannotLeft = false;
                                left = Number($ul.css("left").replace(/px/, ""));
                                if ((scope.status.lisWidth + left) > scope.status.divWidth) {
                                    scope.status.cannotRight = false;
                                } else {
                                    scope.status.cannotRight = true;
                                }
                            });
                        });
                    } else {
                        scope.status.cannotRight = true;
                    }
                });
            };
        }
    };
}]);